import { forwardRef } from "react";

export const PointerIcon = forwardRef(function PointerIcon(p: React.ComponentProps<"svg">, ref) {
  return (
    <svg
      ref={ref as React.ForwardedRef<SVGSVGElement>}
      width="20"
      height="20"
      viewBox="0 0 21 20"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      role="img"
      aria-label="Limit"
      {...p}
    >
      <path d="M7.49971 7.5002L11.6664 17.5002L13.1664 13.1669L17.4997 11.6669L7.49971 7.5002Z" fill="currentColor" />
      <path
        d="M5.99967 1.8335L6.66634 4.25016M4.24967 6.66683L1.83301 6.00016M11.6664 3.41695L9.99971 5.00028M4.9998 10.0002L3.41646 11.6669M7.49972 7.5002L11.6664 17.5002L13.1664 13.1669L17.4997 11.6669L7.49972 7.5002Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
